import { MenuItem } from 'primeng/api';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { MessagesService } from '@core/_services/messages.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { lastValueFrom } from 'rxjs';
import {formatAdminDelegate} from "@core/_utils/tools.utils";

@Component({
    selector: 'app-add-admindelegate',
    // standalone: true,
    templateUrl: './add-admindelegate.component.html',
    styleUrls: ['./add-admindelegate.component.scss'],
})
export class AddAdminDelegateComponent implements OnInit {

    @Input()
    public delegateBase = [];

    @Input()
    public delegateList = [];

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    public items: Array<MenuItem>;


    constructor(
        private translate: TranslateService,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        ) {
        }

    ngOnInit() {
    }

    public async validate(result) {
        let wRes: any = {};
        // id de la requête forcé à 0 : création
        result.entete.id = 0;
        const wdata = formatAdminDelegate(result);
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('updateadmindelegate', wdata ));
            this.onValidate.emit({ data: wRes.data });
        } catch (error) {
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));	
        }
    }

    cancel() {
        this.onCancel.emit({ id: null });
    }
}
